var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMNoticias(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;}.cls-3{fill:#2eccb6;}.cls-4{fill:#329be6;}.cls-5{fill:#0b5c96;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_noticias"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,11H16V50.6a.4.4,0,0,1-.4.4H13.9a.4.4,0,0,1-.4-.4V20.5H11V49.64a3.82,3.82,0,0,0,3,3.78,3.76,3.76,0,0,0,4.54-3.67V13.9a.4.4,0,0,1,.4-.4H50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.75,53.5h.75L20,53C19.94,53.19,19.86,53.35,19.75,53.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,50.6a.4.4,0,0,1-.4.4H13.9a.4.4,0,0,1-.4-.4V46.5L11,44v5.64a3.82,3.82,0,0,0,3,3.78,3.74,3.74,0,0,0,4.23-2.23L16,49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "49 16 54.5 21.5 54.5 16 49 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.5 53.5 54.5 44.5 45.5 53.5 54.5 53.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M.28,32.72a.4.4,0,0,0,0,.56L8.5,41.5v-17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.28.28a.4.4,0,0,0-.56,0L24.5,8.5h17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.72,65.72a.4.4,0,0,0,.56,0L43,56H23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.72,32.72,57,24V42l8.72-8.72A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.5,13.9v.6l1-1h-.6A.4.4,0,0,0,18.5,13.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M54.5,53.5h-9L43,56H56.6a.4.4,0,0,0,.4-.4V42l-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.75,53.5c.11-.15.19-.31.29-.46l-1.85-1.85A3.74,3.74,0,0,1,14,53.42a3.82,3.82,0,0,1-3-3.78V44L8.5,41.5v8.25A6.25,6.25,0,0,0,14.75,56H23l-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M11,20.5h1.5L16,17V11h6l2.5-2.5H13.9a.4.4,0,0,0-.4.4V18H8.9a.4.4,0,0,0-.4.4v6.1L11,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M50,11v2.5H46.5L49,16h5.5v5.5L57,24V13.9a.4.4,0,0,0-.4-.4H52.5V8.9a.4.4,0,0,0-.4-.4H41.5L44,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13.5,50.6a.4.4,0,0,0,.4.4h1.7a.4.4,0,0,0,.4-.4V49l-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "54.5 21.5 54.5 44.5 57 42 57 24 54.5 21.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "20.5 53.5 23 56 43 56 45.5 53.5 20.5 53.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M21,16H49l-2.5-2.5h-27l-1,1V49.75a3.64,3.64,0,0,1-.31,1.44L20,53a6.18,6.18,0,0,0,1-3.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "11 22 8.5 24.5 8.5 41.5 11 44 11 22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "13.5 46.5 16 49 16 17 12.5 20.5 13.5 20.5 13.5 46.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "44 11 41.5 8.5 24.5 8.5 22 11 44 11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,16V49.75a6.24,6.24,0,0,1-1.25,3.75H54.5V16Zm2.47,7.88a.4.4,0,0,1,.4-.4H38.06a.4.4,0,0,1,.4.4V35.6a.4.4,0,0,1-.4.4H23.87a.4.4,0,0,1-.4-.4Zm12,26.72a.4.4,0,0,1-.4.4H23.87a.4.4,0,0,1-.4-.4V48.88a.4.4,0,0,1,.4-.4H35a.4.4,0,0,1,.4.4Zm0-5a.4.4,0,0,1-.4.4H23.87a.4.4,0,0,1-.4-.4V43.88a.4.4,0,0,1,.4-.4H35a.4.4,0,0,1,.4.4Zm0-5a.4.4,0,0,1-.4.4H23.87a.4.4,0,0,1-.4-.4V38.88a.4.4,0,0,1,.4-.4H35a.4.4,0,0,1,.4.4ZM52,50.6a.39.39,0,0,1-.4.4H37.4a.4.4,0,0,1-.4-.4V38.88a.4.4,0,0,1,.4-.4H51.58a.39.39,0,0,1,.4.4Zm0-15a.39.39,0,0,1-.4.4H40.42a.4.4,0,0,1-.4-.4V33.88a.4.4,0,0,1,.4-.4H51.58a.39.39,0,0,1,.4.4Zm0-5a.39.39,0,0,1-.4.4H40.42a.4.4,0,0,1-.4-.4V28.88a.4.4,0,0,1,.4-.4H51.58a.39.39,0,0,1,.4.4Zm0-5a.39.39,0,0,1-.4.4H40.42a.4.4,0,0,1-.4-.4V23.88a.4.4,0,0,1,.4-.4H51.58a.39.39,0,0,1,.4.4Zm0-5a.39.39,0,0,1-.4.4H23.87a.4.4,0,0,1-.4-.4V18.88a.4.4,0,0,1,.4-.4H51.58a.39.39,0,0,1,.4.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 37,
    y: 38.48,
    width: 14.98,
    height: 12.52,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 23.47,
    y: 38.48,
    width: 11.96,
    height: 2.52,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 23.47,
    y: 43.48,
    width: 11.96,
    height: 2.52,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 23.47,
    y: 48.48,
    width: 11.96,
    height: 2.52,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 23.47,
    y: 23.48,
    width: 14.98,
    height: 12.52,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 40.02,
    y: 33.48,
    width: 11.96,
    height: 2.52,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 40.02,
    y: 28.48,
    width: 11.96,
    height: 2.52,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 40.02,
    y: 23.48,
    width: 11.96,
    height: 2.52,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 23.47,
    y: 18.48,
    width: 28.51,
    height: 2.52,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 66,
    height: 66
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMNoticias);
export default __webpack_public_path__ + "static/media/m_noticias.544a1dcb2ae9f791fe3a9899ba595ebd.svg";
export { ForwardRef as ReactComponent };